import { styled } from "@grupoboticario/flora-react";

export const LoadingContainer = styled("div", {
   display: "flex",
   flexDirection: "column", 
   justifyContent: "center",
   alignItems: "center",
   height: "100vh",
   position: "absolute",
   zIndex: 999,
   width: "100%",
   background: "white",
   gap: "10px"
})